export default "__VITE_ASSET__AgepnNiq__"